import { render, staticRenderFns } from "./OwnerDetails.vue?vue&type=template&id=712fed8e&"
import script from "./OwnerDetails.vue?vue&type=script&lang=js&"
export * from "./OwnerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports